import { ActionItem } from '@libs/src/models/action-item.model';
import { ActionQueue } from '@libs/src/models/action-queue.model';
import { Group } from '@libs/src/models/group.model';

export const pageSize = 10;
export interface ActionItemDrawerData {
  actionItems: ActionItem[];
  actionQueueId: ActionQueue['_id'];
  actionQueueStatus: ActionQueue['status'];
  actionQueueType: ActionQueue['action'];
  group: Group;
}

export function getCurrentPageDisplayData(
  displayActionData: ActionItem[],
  pageIndex: number,
) {
  const currentDisplayData = displayActionData.slice(
    (pageIndex - 1) * pageSize,
    pageIndex * pageSize,
  );
  return {
    currentDisplayData,
    allSelectedValuesLength: currentDisplayData.filter((data) => !data.skip)
      .length,
  };
}
